import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURL } from "../../../Config";
import Pagination from "../../Pagination/Pagination";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";

export default function EmployerCustomizationRequest() {
  const token = localStorage.getItem("token");

  const emailid = localStorage.getItem("emailId");
  const [isLoader, setIsLoader] = useState(false);
  const [showPrePage, setShowPrePage] = useState(100);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const tableEmployerCustomizationRequest = React.useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState(null);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const [helpline, setHelpline] = useState([]);
  useEffect(() => {
    getHelpline();
  }, []);

  const getHelpline = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/employercustomizationrequest`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setHelpline(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const remarkChange = (e) => {
    setMessage(e.target.value);
  };
  const handleSubmit = (remark) => {
    console.log("remark", remark);
    console.log("message", message);
    if (message === "") {
      toast.warning("All field required");
    } else {
      const data = {
        emailid: remark?.emailid,
        mobileno: remark?.mobileno,
        remarks: message,
        ownerEmail: emailid,
      };
      axios
        .request(`${APIURL}/corporate/employercustomizationremarks`, {
          method: "POST",
          data: data,
          headers: {
            Authentication: token,

            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response:::::::", response);
          setShowModal(false);
          setMessage("");
          toast.success(response?.data);
          getHelpline();
          setIsLoader(false);
        })
        .catch((error) => {
          setIsLoader(false);
          console.log(error);
        });
    }
  };

  const pop = (e) => {
    console.log("pop func");
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Are you sure?"
        onConfirm={() => {
          setAlert(null);
          deleteEmployerCustomizeRequest(e);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      ></SweetAlert>
    );
  };
  const deleteEmployerCustomizeRequest = (e) => {
    console.log("emailid", e);
    const data = { emailid: e, ownerEmail: emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/deletelead`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        toast.success(response?.data);
        setIsLoader(false);
        getHelpline();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Employer Credit Appraisal
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {alert}
            <div className="pt-3">
              <div className="card">
                <DownloadTableExcel
                  filename="EmployerCustomizationRequest"
                  sheet="users"
                  currentTableRef={tableEmployerCustomizationRequest.current}
                >
                  <button
                    className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                    style={{
                      width: "120px",
                      backgroundColor: "#66a725",
                    }}
                  >
                    Download
                  </button>
                </DownloadTableExcel>
                <div className="p-3 pt-4">
                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            {/* <th style={{ textAlign: "center" }}>Entry Date</th> */}
                            <th style={{ textAlign: "center" }}>
                              Company email
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Employer name
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Contact name
                            </th>
                            <th style={{ textAlign: "center" }}>Mobile</th>
                            <th style={{ textAlign: "center" }}>
                              No. of employees
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Enter remarks by IT dept by clicking on the tabd
                            </th>
                            <th style={{ textAlign: "center" }}>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {helpline?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              {/* <td>{item?.entryDate}</td> */}
                              <td> {item?.emailid}</td>
                              <td>{item?.companyname}</td>
                              <td>{item.employername}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.mobileno}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.noofemployees}
                              </td>
                              {item?.remarks === "" ||
                              item?.remarks === null ? (
                                <td>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      className="btn btn-success"
                                      style={{ width: "150px" }}
                                      onClick={() => {
                                        setRemark(item);
                                        setShowModal(true);
                                      }}
                                    >
                                      Remark
                                    </button>
                                  </div>
                                </td>
                              ) : (
                                <td>{item?.remarks}</td>
                              )}
                              <td>
                                {" "}
                                <div className="d-flex justify-content-center">
                                  <button
                                    className="btn btn-danger"
                                    style={{ width: "150px" }}
                                    onClick={() => {
                                      console.log("clciked delete");
                                      pop(item?.emailid);
                                    }}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        style={{ background: "rgb(255 255 255 / 40%)" }}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Remark</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <input
                            type="text"
                            value={message}
                            onChange={remarkChange}
                            style={{
                              width: "100%",
                              padding: "10px",
                              boxSizing: "border-box",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              marginTop: "10px",
                              fontSize: "18px",
                            }}
                          />
                          <div className="d-flex mt-3 justify-content-end">
                            <button
                              className="btn btn-secondary"
                              style={{ width: "100px" }}
                              onClick={() => setShowModal(false)}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-success ml-2"
                              style={{
                                width: "100px",
                                background: "#66a725",
                              }}
                              onClick={() => handleSubmit(remark)}
                            >
                              Submit
                            </button>
                          </div>
                        </Modal.Body>
                      </Modal>
                    </div>
                  )}
                  {helpline && helpline.length !== 0 && (
                    <Pagination
                      showPrePage={showPrePage}
                      onPaginationChange={onPaginationChange}
                      total={helpline.length}
                    />
                  )}
                  <table
                    className="table table-striped mt-3 "
                    style={{ display: "none" }}
                    ref={tableEmployerCustomizationRequest}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        {/* <th style={{ textAlign: "center" }}>Entry Date</th> */}
                        <th style={{ textAlign: "center" }}>Company email</th>
                        <th style={{ textAlign: "center" }}>Employer name</th>
                        <th style={{ textAlign: "center" }}>Contact name</th>
                        <th style={{ textAlign: "center" }}>Mobile</th>
                        <th style={{ textAlign: "center" }}>
                          No. of employees
                        </th>
                        <th style={{ textAlign: "center" }}>
                          Enter remarks by IT dept by clicking on the tabd
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {helpline?.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          {/* <td>{item?.entryDate}</td> */}
                          <td> {item?.emailid}</td>
                          <td>{item?.companyname}</td>
                          <td>{item.employername}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.mobileno}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.noofemployees}
                          </td>
                          {item?.remarks === "" || item?.remarks === null ? (
                            <td>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn btn-success"
                                  style={{ width: "150px" }}
                                  onClick={() => {
                                    setRemark(item);
                                    setShowModal(true);
                                  }}
                                >
                                  Remark
                                </button>
                              </div>
                            </td>
                          ) : (
                            <td>{item?.remarks}</td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
